import { render, staticRenderFns } from "./CmgRewardsList.vue?vue&type=template&id=0c2b81ac&scoped=true&lang=pug"
import script from "./cmg-rewards-list.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-list.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsList.vue?vue&type=style&index=0&id=0c2b81ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b81ac",
  null
  
)

export default component.exports